import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MarketingLayout, Section, Overline } from "@/marketing/MarketingLayout";
import { PLAN } from "@/marketing/content";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight, CheckCircle2, ShieldCheck } from "lucide-react";

export default function MarketingRegister() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const proceed = () => {
    if (user) navigate("/dashboard");
    else navigate("/auth?mode=signup");
  };

  return (
    <MarketingLayout>
      <Section className="pt-16 pb-16">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <Overline>Register</Overline>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mb-4">Join EliteHire India</h1>
          <p className="text-lg text-muted-foreground">
            One membership, six months of full support — resume, interview coaching, the complete training platform, and direct placement referrals until you're hired.
          </p>
        </div>

        <div className="max-w-lg mx-auto rounded-md border border-primary/40 bg-card overflow-hidden">
          <div className="p-8 text-center border-b border-border">
            <h2 className="font-heading text-2xl font-bold tracking-tight mb-1">{PLAN.name}</h2>
            <p className="text-sm text-muted-foreground mb-5">{PLAN.tagline}</p>
            <div className="flex items-end justify-center gap-2 mb-6">
              <span className="font-mono text-5xl font-black">{PLAN.price}</span>
              <span className="text-muted-foreground mb-1">/ {PLAN.period}</span>
            </div>
            <Button size="lg" onClick={proceed} className="rounded-md gap-2 h-12 px-6 w-full" data-testid="register-proceed">
              {user ? "Go to my dashboard" : "Create my account"} <ArrowRight className="w-4 h-4" />
            </Button>
            <p className="text-xs text-muted-foreground mt-3">
              {user ? "You're signed in." : "You'll create your account, then our team activates your 6-month access."}
            </p>
          </div>
          <div className="p-8">
            <p className="font-heading font-bold mb-4">What's included</p>
            <ul className="space-y-3">
              {PLAN.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm" data-testid="register-feature">
                  <CheckCircle2 className="w-4 h-4 text-success shrink-0 mt-0.5" /><span className="text-muted-foreground">{f}</span>
                </li>
              ))}
            </ul>
            <div className="flex items-start gap-2 mt-6 pt-5 border-t border-border text-sm text-muted-foreground">
              <ShieldCheck className="w-4 h-4 text-success shrink-0 mt-0.5" /> {PLAN.guarantee}
            </div>
          </div>
        </div>

        <p className="text-center text-sm text-muted-foreground mt-8">
          Already have an account?{" "}
          <button onClick={() => navigate("/auth")} className="text-primary font-medium hover:underline" data-testid="register-signin-link">Sign in</button>
        </p>
      </Section>
    </MarketingLayout>
  );
}
